module.exports = __webpack_public_path__ + "img/1-2.037936b8.svg";